import React, { Component } from 'react';
import './Form.css'
import Option from './Option'
import Phone from './Phone'

class Form extends Component {
    constructor () {
        super()
    }

    render(){
        return(
            <div className="form">
                <form>
                    <Option fave={this.props.fave} name="Dalmation Cookie" handleChange={this.props.handleChange}/>
                    <Option fave={this.props.fave} name="Sizzling Pasta" handleChange={this.props.handleChange}/>
                    <Option fave={this.props.fave} name="Sweet Yeasty Roll" handleChange={this.props.handleChange}/>
                    <Option fave={this.props.fave} name="Scrambled Eggs" handleChange={this.props.handleChange}/>  
                    <Option fave={this.props.fave} name="Potato Gems" handleChange={this.props.handleChange}/> 
                    <Option fave={this.props.fave} name="Spicy Fried Cheese Ravioli" handleChange={this.props.handleChange}/> 
                    <Option fave={this.props.fave} name="Iced Cinnamon Roll" handleChange={this.props.handleChange}/> 
                    <Option fave={this.props.fave} name="Waffle Fries" handleChange={this.props.handleChange}/> 
                    <Option fave={this.props.fave} name="None!" handleChange={this.props.handleChange}/>    
                    <br/>
                </form> 
                <Phone submit = {this.props.submit} number={this.props.number} carrier={this.props.carrier}/>
            </div>
        )
    }
}

export default Form


// WEBPACK FOOTER //
// ./src/Form.js